import React from 'react';
import '../less/index.less'
import hero_img from '../img/hero_img.png';
import Hero from '../../../../../auxiliary-components/shared/HeroBlock';
import how_to_block_img_1 from '../img/how_to_block_img_1.png';
import how_to_block_img_2 from '../img/how_to_block_img_2.png';
import how_to_block_img_3 from '../img/how_to_block_img_3.png';
import how_to_block_img_4 from '../img/how_to_block_img_4.png';
import additional_product_img_1 from '../img/additional_product_img_1.png';
import additional_product_img_2 from '../img/additional_product_img_2.png';
import HowToBlockNew from '../../../../../auxiliary-components/shared/HowToBlockNew';
import how_to_block_items from '../enums/how_to_block_items.json';
import additional_cards_data from '../enums/additional_cards_data.json';
import AdditionalProduct from '../../../../../auxiliary-components/shared/AdditionalProductBlock';
import hero_data from '../enums/hero_data.json';
import FilesForDownloadNew from '../../../../../auxiliary-components/shared/FilesForDownloadNew';

export default function template() {
  const page = 'invite-friend';

  const imagesMap = {
    how_to_block_img_1,
    how_to_block_img_2,
    how_to_block_img_3,
    how_to_block_img_4,
    additional_product_img_1,
    additional_product_img_2
  };

  const howToBlockItems = how_to_block_items.map(item => ({
    ...item,
    img: imagesMap[item.img]
  }));

  const additionalCards = additional_cards_data.map(item => ({
    ...item,
    img: imagesMap[item.img]
  }));

  return (
    <div className="invite-friend">
      <Hero
        data={hero_data}
        img={hero_img}
        page={page}
      />
      <div className="content">
        <HowToBlockNew
          title={'INVITE_FRIEND_NEW_HOW_TO_TITLE'}
          items={howToBlockItems}
        />
        <AdditionalProduct
          items={additionalCards}
          title={'INVITE_FRIEND_NEW_ADDITIONAL_PRODUCT_TITLE'}
          page={page}
        />
        <FilesForDownloadNew
          widget={this.widgetsHelper.getWidget.call(this, 'files_to_download')}
          loader={this.state.loader}
        />
      </div>
    </div>
  );
}
